import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import ReportTableBreakout from "Reporting/Components/ReportTableBreakout";
import { useBreakoutGet } from "./useBreakoutGet";
import Loader from "shared/Loader";

/*
 * Table displaying different items in a report using Diamond integration
 */
export default function ReportTableListBreakout({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const [reports, setReports] = useState([]);
  // Store sorted Breakout data for each report index
  const [sortedBreakoutData, setSortedBreakoutData] = useState([]);

  const { data, isLoading, isError, refetch } = useBreakoutGet({
    type: filters.type,
    year: filters.year,
    events: filters.events,
    eventSetId: filters.eventSetId ?? null,
  });
  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      refetch?.();
    }
  }, [fetchTrigger]);
  useEffect(() => {
    if (data) {
      // Collect all unique report titles
      const uniqueTitles = Array.from(
        new Set(data.flatMap((item) => item.reportTitle || []))
      );

      // Build grouped reports
      const groupedReports = uniqueTitles.map((title) => ({
        title,
        reports: data.filter((item) =>
          (item.reportTitle || []).includes(title)
        ),
      }));

      setReports(groupedReports);
      setReportsLength?.(groupedReports.length || 0);
      // Reset sorted Breakout data when new data arrives
      setSortedBreakoutData(Array(groupedReports.length).fill(undefined));
      setReportData?.(groupedReports);
    }
  }, [data]);

  // When all sorted Breakout data is available, pass up to parent
  useEffect(() => {
    if (
      reports.length > 0 &&
      sortedBreakoutData.length === reports.length &&
      sortedBreakoutData.every((d) => Array.isArray(d))
    ) {
      // Attach sorted Breakout data to each report object for PDF export
      const reportsWithSorted = reports.map((report, idx) => ({
        ...report,
        sortedBreakoutData: sortedBreakoutData[idx],
      }));
      setReportData?.(reportsWithSorted);
    }
  }, [sortedBreakoutData, reports, setReportData]);

  if (isError) {
    return <div>Something went wrong...</div>;
  }
  if (isLoading) {
    return <Loader />;
  }
  if (reports.length === 0) {
    return <div>No Reports Found</div>;
  }

  return (
    <div className={styles.container}>
      {reports.map((report, index) => (
        <React.Fragment key={index}>
          <ReportTableBreakout
            reports={report.reports}
            title={report.title}
            onSortedReportsChange={(sorted) => {
              setSortedBreakoutData((prev) => {
                const next = [...prev];
                next[index] = sorted;
                return next;
              });
            }}
          />
        </React.Fragment>
      ))}
    </div>
  );
}
